import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { app } from "../../Frame/App";
import { Picture } from "../../Frame/Picture";

export class ColumnPicture extends ColumnBase {

    public getContent(row: any): HTMLElement {
        if (this.field && this.field.startsWith("LF#") && row[this.field] === "True") {
            let fieldId = parseInt(this.field.substr(3));
            let cellId = app.createGuid();
            const img: HTMLImageElement = <img className="mt-picture" id={cellId} src={app.resolveUrl(`~/api/documents/getFirstPictureForTableCell/${row.Id}/${fieldId}`)} />;
            img.addEventListener("click", (ev: MouseEvent) => {
                ev.stopPropagation();
                ev.cancelBubble = true;
                app.showWaitPanel();
                $.get(app.resolveUrl(`~/api/documents/getFirstPictureForCellPopup/${row.Id}/${fieldId}`), (id: number) => {
                    app.hideWaitPanel();
                    Picture.show(id, "");
                }).fail(() => {
                    app.hideWaitPanel();
                });
            });

            // If a measure has documents but none of them are images, diplay a check
            $.get(app.resolveUrl(`~/api/documents/getFieldHasOnlyNonPictureDocuments/${row.Id}/${fieldId}`), (result: Boolean) => {
                if (result) {
                    let element = document.getElementById(cellId);
                    if (element) {
                        element.replaceWith(<i className="fa fa-check"></i>);
                    }
                }
            });

            return img;
        }
        return <span></span>;
    }
}